export const animationsTime = '150ms';
